import request from '../request'

export default {
  getOrganismos: function () {
    return request.get('organismo')
  }
}
